// extracted by mini-css-extract-plugin
export var filterButton = "_ob-1";
export var filtersContainer = "_ob-0";